import React, { useCallback } from "react";
import { CustomFieldType } from "../../../../types/custom-fields/custom-field-type";
import { format, parse } from "date-fns";
import { it } from "date-fns/locale";
export function CustomFieldInput({ value, type, className, onChange, onEnter }: { value: string | number | boolean | undefined, type: CustomFieldType, className?: string, onChange: (value: string | number | boolean | undefined) => void, onEnter?: () => void }): JSX.Element {
  const props: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> = {}
  switch (type) {
    case 'email':
      props.value = value as string
      props.type = 'email'
      break;
    case 'phone_number':
      props.value = value as string
      props.type = 'tel'
      break;
    case 'text_multiline':
      props.value = value as string
      props.type = 'text'
      props["aria-multiline"] = true
      break;
    case 'checkbox':
      props.type = 'checkbox'
      props.checked = value as boolean ?? false
      break;
    case 'date':
      if (value) {
        const parsed = parseDateFormats(value as string, ['dd/MM/yyyy', 'dd-MM-yyyy', 'dd.MM.yyyy'])
        if (parsed) {
          props.value = format(parsed, 'yyyy-MM-dd')
        }
      }
      props.form = 'dd/MM/yyyy'
      props.type = 'date'
      break;
    case 'fiscal_code':
    case 'text':
    default:
      props.value = value as string
      props.type = 'text'
  }

  const onInputChange = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    let value
    if (type === 'checkbox') {
      value = e.target.checked
    } else {
      value = e.target.value
      if (!value.trim()) {
        value = undefined
      } else {
        if (type === 'date') {
          value = value ? format(parse(value, 'yyyy-MM-dd', new Date()), 'dd/MM/yyyy', { locale: it }) : value
        }
      }
    }
    onChange(value)
  }, [onChange, type])

  return (<input
    onChange={onInputChange}
    className={`h-10 py-1 pl-4 border-0 text-base lg:text-lg bg-cents-grey rounded-2xl focus:ring-0 ${type === 'checkbox' ? "h-5 w-5 ml-4 my-2.5" : ""}`.concat(className ? ` ${className}` : "")}
    onKeyUp={(e) => { if (e.key === 'Enter') { onEnter?.() } }}
    {...props}
  />)
}


function parseDateFormats(value: string, formats: string[]): Date | undefined {
  for (const fmt of formats) {
    const parsed = parse(value, fmt, new Date())
    if (!isNaN(parsed.getTime())) {
      return parsed
    }
  }
  return undefined // Invalid date
};